export const SYMBOLS = {
    '🍒': { value: 10, frequency: 0.3 },
    '🍊': { value: 20, frequency: 0.25 },
    '💎': { value: 50, frequency: 0.2 },
    '7️⃣': { value: 100, frequency: 0.15 },
    '🍀': { value: 200, frequency: 0.1 }
} as const;

export const SPIN_COST = 10;
export const SPIN_ANIMATION_DURATION = 1000; // milliseconds 